export { Chip } from './Chip'
export type { ChipProps, ChipVariant } from './Chip'
